import { ComponentProps, FC } from 'react'
import cn from 'classnames'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import { PhoneIcon } from '@/utils/icons'
import type { CrmLeadTelephonyEndpoint } from '@/api/types/crm/crmLeadFunnels.types'
import { formatCrmChatUnreadBadge } from '@pages/Admin/CRM/utils/leadFields'
import classes from '../index.module.css'

type TelephonyIconSlotsProps = {
  endpoints: CrmLeadTelephonyEndpoint[]
  phoneNumber?: string
  badgeSize: 'table' | 'card' | 'kanban'
  useStackedIconLook: boolean
  tooltipProps?: ComponentProps<typeof TooltipWrapper>
  onPickEndpoint: (endpoint: CrmLeadTelephonyEndpoint) => void
}

const TelephonyIconSlots: FC<TelephonyIconSlotsProps> = ({
  endpoints,
  phoneNumber,
  badgeSize,
  useStackedIconLook,
  tooltipProps,
  onPickEndpoint,
}) => (
  <>
    {endpoints.map((endpoint) => {
      const unreadLabel = formatCrmChatUnreadBadge(
        Number(endpoint.unread_count ?? 0),
      )
      const canCall =
        Boolean(endpoint.outgoing_calls_enabled) && Boolean(phoneNumber?.trim())

      return (
        <span
          key={`telephony-${endpoint.id}`}
          className={cn(
            classes.iconSlot,
            Boolean(unreadLabel) && classes.iconSlotWithBadge,
          )}
        >
          <TooltipWrapper title={endpoint.name} {...tooltipProps}>
            <div
              className={cn(
                classes.linkWrapper,
                classes.telephonyLinkWrapper,
                useStackedIconLook && classes.linkWrapper_stacked,
                badgeSize === 'kanban' && classes.linkWrapper_kanban,
                badgeSize === 'card' && classes.linkWrapper_card,
              )}
              style={{ cursor: canCall ? 'pointer' : 'default' }}
              role="button"
              tabIndex={canCall ? 0 : -1}
              aria-label={endpoint.name}
              onClick={() => {
                if (!canCall) return
                onPickEndpoint(endpoint)
              }}
              onKeyDown={(e) => {
                if (!canCall) return
                if (e.key !== 'Enter' && e.key !== ' ') return
                e.preventDefault()
                onPickEndpoint(endpoint)
              }}
            >
              <PhoneIcon style={{ fill: 'var(--color-button-primary-bg)' }} />
              {unreadLabel ? (
                <span
                  className={cn(
                    classes.vkUnreadBadge,
                    classes[`vkUnreadBadge_${badgeSize}`],
                  )}
                  aria-label="Пропущенные звонки"
                >
                  {unreadLabel}
                </span>
              ) : null}
            </div>
          </TooltipWrapper>
        </span>
      )
    })}
  </>
)

export default TelephonyIconSlots
